import * as _ from "lodash";

import { IList } from "src/core/lists/api/lists.api";

export default (productId: number, currentList: IList | null) => {
  if (currentList) {
    const productListLine = _.find(currentList.listLines, listLine => listLine.productId === productId);

    if (productListLine) {
      return productListLine.quantity;
    }
  }

  return 0;
};
